module.exports = "https://static.wmbcdn.com/uniweb/images/dcf7dd077b15de3ccc5a67a6c78b9ac0.svg";